export let ExternalModuleName = /*#__PURE__*/function (ExternalModuleName) {
  ExternalModuleName["React"] = "react";
  ExternalModuleName["ReactDOM"] = "react-dom";
  ExternalModuleName["ReactIntlNext"] = "react-intl-next";
  ExternalModuleName["EmotionReact"] = "@emotion/react";
  ExternalModuleName["FeatureGateJsClientPublic"] = "@atlaskit/feature-gate-js-client";
  ExternalModuleName["AnalyticsContext"] = "@atlaskit/analytics-next-stable-react-context";
  return ExternalModuleName;
}({});
export let PluginName = /*#__PURE__*/function (PluginName) {
  PluginName["AppSwitcher"] = "app-switcher";
  PluginName["PostOffice"] = "post-office";
  return PluginName;
}({});

/** The importmap standard is defined here: https://github.com/WICG/import-maps */